import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import FotoscapeLink from '../FotoscapeLink/FotoscapeLink';
import Image from '../Image/Image';
import {
  SECTION_LINK_LIST_ABOUT,
  SECTION_LINK_LIST_LEGAL,
  SECTION_LINK_LIST_RECOMENDATION,
  SECTION_LINK_LIST_SOCIAL,
} from './constants';
import fotoSCAPEImg from '/assets/images/FotoSCAPE.svg?url';
import Icon from '../Icon/Icon.tsx';

import './index.scss';

const Footer: FC = () => {
  const { t } = useTranslation();

  const onClick = () => {
    window.scroll({ top: 0 });
  };

  return (
    <div className="footer" id="footer" data-testid="footer">
      <div className="footer__main">
        <div className="footer__main-container">
          <div className="footer__section">
            <Image className="footer__logo" src={fotoSCAPEImg} alt="logo" />
            <div className="footer__description label--s">
              {t('everydayLifestyle')}
            </div>
            <div className="footer__follow headline--xs">{t('followUs')}</div>

            <div className="footer__social">
              {SECTION_LINK_LIST_SOCIAL.map(({ icon, link, text }) => {
                return (
                  <FotoscapeLink
                    className="footer__social-link"
                    key={link}
                    to={link}
                    aria-label={text}
                  >
                    <Icon type={icon} />
                  </FotoscapeLink>
                );
              })}
            </div>
            <div className="footer__text footer__text--tabled footer__text--gray label--s">
              © 2024
            </div>
          </div>

          <div className="footer__section">
            {SECTION_LINK_LIST_RECOMENDATION.map(({ text, link }) => {
              return (
                <FotoscapeLink
                  key={link}
                  className="footer__text footer__text--uppercase footer__text--gray label--m"
                  to={link}
                  onClick={onClick}
                >
                  {t(text)}
                </FotoscapeLink>
              );
            })}
          </div>

          <div className="footer__section">
            {SECTION_LINK_LIST_ABOUT.map(({ text, link }) => {
              return (
                <FotoscapeLink
                  key={link}
                  className="footer__text label--s"
                  to={link}
                >
                  {t(text)}
                </FotoscapeLink>
              );
            })}
          </div>

          <div className="footer__section">
            {SECTION_LINK_LIST_ABOUT.map(({ text, link }) => {
              return (
                <FotoscapeLink
                  key={link}
                  className="footer__text footer__text--mobile label--s"
                  to={link}
                  onClick={onClick}
                >
                  {t(text)}
                </FotoscapeLink>
              );
            })}

            {SECTION_LINK_LIST_LEGAL.map(({ text, link }) => {
              return (
                <FotoscapeLink
                  key={link}
                  className="footer__text label--s"
                  to={link}
                  onClick={onClick}
                >
                  {t(text)}
                </FotoscapeLink>
              );
            })}
          </div>
          <div className="footer__text footer__text--copyright footer__text--mobile footer__text--gray label--s">
            © 2024
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
